import type { BrandLogoType } from '@/models';

/**
 * Space in the folder name must be URL-encoded or the browser/Next
 * image loader will fail to resolve the asset.
 */
const BRAND_ICONS_DIR = '/icons/phones%20brands%20icons%20500x500';
const DEFAULT_BRAND_LOGO = '/favicon/android-chrome-192x192.png';

const BRAND_LOGO_SRC: Record<BrandLogoType, string> = {
  samsung: `${BRAND_ICONS_DIR}/samsung.svg`,
  apple: `${BRAND_ICONS_DIR}/apple.svg`,
  xiaomi: `${BRAND_ICONS_DIR}/xiaomi.svg`,
  redmi: `${BRAND_ICONS_DIR}/redmi.svg`,
  huawei: `${BRAND_ICONS_DIR}/huawei.svg`,
  oppo: `${BRAND_ICONS_DIR}/oppo.svg`,
  infinix: `${BRAND_ICONS_DIR}/infinix.svg`,
  tecno: `${BRAND_ICONS_DIR}/tecno.svg`,
  honor: `${BRAND_ICONS_DIR}/honor.svg`,
  vivo: `${BRAND_ICONS_DIR}/vivo.svg`,
  poco: `${BRAND_ICONS_DIR}/poco.svg`,
  oneplus: `${BRAND_ICONS_DIR}/oneplus.svg`,
  google: `${BRAND_ICONS_DIR}/google.svg`,
  itel: `${BRAND_ICONS_DIR}/itel.svg`,
  default: DEFAULT_BRAND_LOGO,
};

const BRAND_LOGO_TYPE_BY_SLUG: Record<string, BrandLogoType> = {
  samsung: 'samsung',
  apple: 'apple',
  xiaomi: 'xiaomi',
  redmi: 'redmi',
  huawei: 'huawei',
  oppo: 'oppo',
  infinix: 'infinix',
  tecno: 'tecno',
  honor: 'honor',
  vivo: 'vivo',
  poco: 'poco',
  oneplus: 'oneplus',
  google: 'google',
  itel: 'itel',
};

export function getBrandLogoSrc(logoType: BrandLogoType): string {
  return BRAND_LOGO_SRC[logoType] ?? DEFAULT_BRAND_LOGO;
}

export function getBrandLogoType(slug: string): BrandLogoType {
  return BRAND_LOGO_TYPE_BY_SLUG[slug] ?? 'default';
}
